/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import { ThemeProp } from "../../../../styles/theme";
import { css } from "@emotion/react";
import { BaseButtonProps } from "../Button";

interface ButtonContainerProps extends BaseButtonProps, ThemeProp {}

const getBackgroundColorStates = (
  props: ButtonContainerProps
): { default: string; disabled: string; active: string; hover: string; waiting?: string } => {
  const { buttonType, theme } = props;
  if (buttonType && buttonType === "link") {
    return {
      default: "transparent",
      disabled: "transparent",
      active: "transparent",
      hover: "transparent",
    };
  }
  if (buttonType && theme.button[buttonType]?.surface) {
    return theme.button[buttonType].surface;
  }

  // Primary button colour fallback
  return theme.button.primary.surface;
};
export const getTextColorStates = (
  props: ButtonContainerProps
): { default: string; disabled: string; active: string; hover: string; waiting?: string } => {
  const { buttonType, theme } = props;
  if (buttonType && theme.button[buttonType]?.text) {
    return theme.button[buttonType].text;
  }

  // Primary button colour fallback
  return theme.button.primary.surface;
};

export const ButtonContainer = styled.button<ButtonContainerProps>(props => {
  const backgroundColorStates = getBackgroundColorStates(props);
  const textColorStates = getTextColorStates(props);
  const activeState = css`
    ${props.hasActiveState &&
    `
     backgroundColor: backgroundColorStates.active,
     color: textColorStates.active,
        
    &:active {
      transform: scale(0.95);
    }
  `}
  `;

  let width: string | number = "auto";
  if (props.widthExpand) {
    width = "100%";
  } else if (props.width) {
    width = props.width;
  }

  return {
    backgroundColor: backgroundColorStates.default,
    color: textColorStates.default,
    display: "flex",
    alignItems: "center",
    gap: 6,
    border: "none",
    padding: props.padding ?? "6px 18px",
    height: props.height ? `${props.height}px` : "auto",
    width,
    borderRadius: props.shape === "round" ? "21px" : "8px",

    transition: "background-color 0.2s linear, color 0.2s linear",
    outline: "none",

    "&:hover": {
      backgroundColor: backgroundColorStates.hover,
      color: textColorStates.hover,
    },

    "&:disabled": {
      backgroundColor: props.isWaiting
        ? backgroundColorStates.waiting
        : backgroundColorStates.disabled,
      color: props.isWaiting ? textColorStates.waiting : textColorStates.disabled,
    },
    activeState,
    ...props.buttonCss,
  };
});
